// src/components/Solutions.js
import React from 'react';
import './Solutions.css';
//import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Solutions = ({ solutionsData, sectionTitle, sectionSubtitle, showButton = true }) => {
    
    const location = useLocation(); // Get current location

    // Conditional styles based on the route
    let h2MaxWidth = '600px'; // Default maxWidth for h2
    let sectionMarginTop; // Default marginTop for section

    if (location.pathname === '/for-independent-practices') {
        h2MaxWidth = '800px'; // Only set maxWidth for h2
    } else if (location.pathname === '/for-new-practices') {
        h2MaxWidth = '800px'; // Set maxWidth for h2
        sectionMarginTop = '40px'; // Also reduce marginTop for section
    } else if (location.pathname === '/for-consultant-physicians') {
        h2MaxWidth = '900px'; // Set maxWidth for h2
        sectionMarginTop = '20px'; // Also reduce marginTop for section
    } else if (location.pathname === '/for-general-practitioners') {
        h2MaxWidth = '700px'; // Set maxWidth for h2
        sectionMarginTop = '-10px'; // Also reduce marginTop for section
    } else if (location.pathname === '/for-dermatologists') {
        h2MaxWidth = '750px'; // Set maxWidth for h2
        sectionMarginTop = '10px'; // Also reduce marginTop for section
    }


    
    return (
        // <section id="solutions" className="solutions-section" style={{ marginTop: sectionMarginTop }}>
        //     <h5>{sectionSubtitle && 'Solutions'} </h5>
        //     <h2 style={{ maxWidth: h2MaxWidth }} > {sectionTitle || "Tomorrow’s solutions for today’s provider"}</h2>
        //     {solutionsData.map((solution, index) => (
        //         <div
        //             className={`solution-item ${index % 2 === 0 ? 'row-reverse' : ''}`}
        //             key={solution.id}
        //         >
        //             {/* Image Section */}
        //             <div className="solution-image">
        //                 <img src={solution.image} alt={solution.title} />
        //             </div>
        //             {/* Text Section */}
        //             <div className="solution-text">
        //                 <h5 className="solution-subtitle">{solution.subtitle}</h5>
        //                 {/* <h3>{solution.title}</h3>
        //                 <p>{solution.text}</p> */}
        //                 <h3 clasName="solution-title">{solution.title}</h3>
        //                 <p className="solution-description">{solution.text}</p>
        //                 {showButton && (
        //                     <RouterLink
        //                         to={solution.link}                               
        //                         className="btn primary-btn"                               
        //                     >
        //                         {solution.buttonLabel}
        //                     </RouterLink>
        //                 )}
        //             </div>
        //         </div>
        //     ))}
        // </section>


        // <section id="solutions" className="solutions-section" style={{ marginTop: sectionMarginTop }}>
        //     <h5>{sectionSubtitle && 'Solutions'} </h5>
        //     <h2 style={{ maxWidth: h2MaxWidth }} > {sectionTitle || "Tomorrow’s solutions for today’s provider"}</h2>
        //     {solutionsData.map((solution, index) => (
        //         <div
        //             className={`solution-item ${index % 2 === 0 ? 'row-reverse' : ''}`}
        //             key={solution.id}
        //         >
        //             <h3 clasName="solution-title">{solution.title}</h3>
        //             {/* Image Section */}
        //             <div className="solution-image">
        //                 <img src={solution.image} alt={solution.title} />
        //             </div>

                    
        //             {/* Text Section */}
        //             <div className="solution-text">
        //                 <h5 className="solution-subtitle">{solution.subtitle}</h5>
        //                 {/* <h3>{solution.title}</h3>
        //                 <p>{solution.text}</p> */}
                        
        //                 <p className="solution-description">{solution.text}</p>
        //                 {showButton && (
        //                     <RouterLink
        //                         to={solution.link}                               
        //                         className="btn primary-btn"                               
        //                     >
        //                         {solution.buttonLabel}
        //                     </RouterLink>
        //                 )}
        //             </div>
        //         </div>
        //     ))}
        // </section>

        <section id="solutions" className="solutions-section" style={{ marginTop: sectionMarginTop }}>
            <h5>{sectionSubtitle && 'Solutions'} </h5>
            <h2 style={{ maxWidth: h2MaxWidth }} > {sectionTitle || "Tomorrow's solutions for today's provider"}</h2>
            {solutionsData.map((solution, index) => (
                <div
                    className={`solution-item ${index % 2 === 0 ? 'row-reverse' : ''}`}
                    key={solution.id}
                >   

                    {/* Image Section */}
                    <div className="solution-image">
                        {/* Mobile Section Title */}
                        <div class="solution-text MobileSection">
                            <h3 class="solution-title">{solution.title}</h3>
                        </div>
                        <img src={solution.image} alt={solution.title} />
                    </div>

                    {/* Text Section Desktop */}
                    <div className="solution-text">
                        <h5 className="solution-subtitle">{solution.subtitle}</h5>
                        <h3 className="solution-title DesktopSection">{solution.title}</h3>
                        <p className="solution-description">{solution.text}</p>
                        {showButton && (
                            <RouterLink
                                to={solution.link}                               
                                className="btn primary-btn"                               
                            >
                                {solution.buttonLabel}
                            </RouterLink>
                        )}
                    </div>
                </div>
            ))}
        </section>

        
    );
};

export default Solutions;
